
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/shareListings/[id]",
      function () {
        return require("private-next-pages/admin/shareListings/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/shareListings/[id]"])
      });
    }
  